import React from "react";
import { Divider } from "antd";

import { FormDividerText } from "../styledComponents";
import { GRAY_300 } from "../../../../../constant/colors";

/**
 * Native JSON field type `divider`: the JSON-renderer equivalent of the in-section sub-dividers the
 * hand-written forms drew with `<Divider orientation="left" style={{ color: GRAY_300 }}><FormDividerText>`
 * (e.g. the "Commercial Medical/Pharmacy Insurance Information" and "Doctor information" / "Treating
 * facility information" headers). Display-only: binds no value. `anchorId` reproduces the old sidebar
 * scroll target (`<div id="enrollment-form-..." />`) so a `layout: "bare"` section still has an anchor.
 *
 * FormJson usage:
 *   { "type": "divider", "name": "", "colSize": 24,
 *     "dedicatedFieldProps": { "title": "Commercial Medical Insurance Information",
 *                              "anchorId": "enrollment-form-insurance" } }
 */
export const DividerField = ({ title, anchorId }) => (
  <Divider {...(anchorId ? { id: anchorId } : {})} orientation="left" orientationMargin="0" style={{ color: GRAY_300 }}>
    <FormDividerText>{title}</FormDividerText>
  </Divider>
);

export default DividerField;
